<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { Locale } from "@core/schema/Locale.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import type { WholesalePartnerCardProps } from "./WholesalePartnerCardProps.js";

	const { tenant } = getGlobalTemplateProps();
	const { partner }: WholesalePartnerCardProps = $props();

	const quoteStyles = {
		[Locale.cs]: {
			start: "„",
			end: "“",
		},
		[Locale.en]: {
			start: '"',
			end: '"',
		},
	};
</script>

<article class="rounded-2xl border border-fcrlightgray-300 flex flex-col w-81.5 p-4 gap-8">
	<div>
		{quoteStyles[tenant.locale].start}<Formatted text={partner.cite} />{quoteStyles[tenant.locale].end}
	</div>
	<div class="mt-auto flex items-center justify-between">
		<div class="text-fcrdarkgray font-medium text-5/tighter font-antipol grow shrink tracking-normal">
			<Formatted text={partner.author} />
		</div>
	</div>
</article>
